import { render, staticRenderFns } from "./DescargarLiquidaciones.vue?vue&type=template&id=425264fd"
import script from "./DescargarLiquidaciones.vue?vue&type=script&lang=js"
export * from "./DescargarLiquidaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports